.material_symbols_outlined {
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword -- this has no generic family */
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  overflow-wrap: normal;
  direction: ltr;
  -moz-font-feature-settings: 'liga';
  font-feature-settings: 'liga';
  -moz-osx-font-smoothing: grayscale;
}
